import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const ClientRouteTemplate = ({ db, currentUser, Component, componentName }) => {
  const { clientId } = useParams();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClient = async () => {
      if (!clientId) {
        setError('ID client manquant');
        setLoading(false);
        return;
      }

      try {
        const clientDoc = await getDoc(doc(db, 'clients', clientId));
        if (clientDoc.exists()) {
          setClient({ id: clientDoc.id, ...clientDoc.data() });
        } else {
          setError('Client non trouvé');
        }
      } catch (err) {
        console.error(`Erreur lors du chargement du client pour ${componentName}:`, err);
        setError('Erreur lors du chargement du client');
      } finally {
        setLoading(false);
      }
    };

    fetchClient();
  }, [clientId, db, componentName]);

  // Charger les permissions de l'utilisateur
  useEffect(() => {
    const loadUserPermissions = async () => {
      if (!currentUser?.role) return;
      
      try {
        const roleDoc = await getDoc(doc(db, 'roles', currentUser.role));
        if (roleDoc.exists()) {
          const permissions = roleDoc.data().permissions || [];
          const permissionsObj = permissions.reduce((acc, perm) => {
            acc[perm] = true;
            return acc;
          }, {});
          setUserPermissions(permissionsObj);
        }
      } catch (error) {
        console.error('Erreur lors du chargement des permissions:', error);
      }
    };

    if (currentUser) {
      loadUserPermissions();
    }
  }, [currentUser, db]);

  const hasPermission = (permission) => {
    return !!userPermissions[permission];
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg">Chargement du client...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center h-64">
        <div className="text-red-600 text-lg mb-4">{error}</div>
        <button
          onClick={() => navigate('/dashboard/resources')}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Retour à la gestion des clients
        </button>
      </div>
    );
  }

  if (!client) {
    return (
      <div className="flex flex-col justify-center items-center h-64">
        <div className="text-red-600 text-lg mb-4">Client non trouvé</div>
        <button
          onClick={() => navigate('/dashboard/resources')}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Retour à la gestion des clients
        </button>
      </div>
    );
  }

  return (
    <Component
      client={client}
      db={db}
      currentUser={currentUser}
      hasPermission={hasPermission}
    />
  );
};

export default ClientRouteTemplate;
